export default "__VITE_ASSET__de3fa74d__"